enum FilterValues {
    status = 'status',
    published = 'PUBLISHED',
    contentType = 'contentType',
    studyMaterial = 'studymaterial',
}

export let preSelectedFilter = {
    contentMenu: "all",
    goalsDriller: {},
    ommitSubjectDetails: false,
    excludedIds: [],
    contentFilterData: [{
        filterValue: FilterValues.contentType,
        isSelected: true,
        disabled: false,
        filters: []
    },
    {
        filterValue: FilterValues.status,
        isSelected: true,
        filters: [{
            filterValue: FilterValues.published,
            isSelected: true,
            filters: []
        }],
    }
    ]
}